define('shared/initializer/form/newHouseAdapters/mixins/UpdateMemberInfoInMemberPage',[
    'shared/lib/RSVP',
    'shared/util/state',
    'shared/page/wcmmode',
    'shared/util/fields/common',
    'shared/my/identity',
    'shared/my/cmus',
    'shared/initializer/form/constants',
    'shared/util/checkout/member',
    'shared/remote/member/update',
],
function (
    RSVP,
    state,
    getWCMMode,
    fieldUtil, 
    getIdentity, 
    getCMus,
    constants, 
    memberUtil,
    updateMember
) {
    'use strict';

    function Ctor() { }

    function getFieldValue(fieldName) {
        var me = this;
        return me.items.get(fieldName) && me.items.get(fieldName).$el.val();
    }

    function updateWithMemberFormData() {
        var me = this;
        var payload = {phones:{}};
        var telephone = getFieldValue.call(me, 'telephone');
        if (telephone) {
            payload.phones.telephone = telephone;
        }
        return updateMember(payload);
    }

    Ctor.prototype.doPageLoad = function(){
        if(!memberUtil.isUpdatingMemberInfo()){
            return RSVP.resolve();
        }

        return RSVP.resolve();
    };

    Ctor.prototype.doSubmit = function(data){
        if(!memberUtil.isUpdatingMemberInfo()){
            return RSVP.resolve()
                .then(function() {
                    return data;
                });
        }

        var me = this;

        return RSVP.resolve()
            .then(function(){
                return getWCMMode();
            })
            .then(function(wcmmode){
                if (wcmmode === 'edit') {
                    return RSVP.resolve();
                }
                else {
                    return updateWithMemberFormData.call(me);
                }
            });
    };

    return Ctor;
});

